import React, { useState, useEffect } from "react";
import LaunchpadComponent from "../Launchpad/LaunchpadComponent";
import {
  _InfinityFactoryContractGetAllDataByAddress,
  _IDOSaleTotalCollectedFunds,
} from "../../Services/Web3Connection";
import Pagination from "../Pagination";
import Loading from "../Animation/Loading/Loading";
import AllIDOSequence from "./AllIDOSequence";

function AllIDO() {
  const [FactoryContract, setFactoryContract] = useState(null);
  const [Activedata, setActivedata] = useState([]);
  const [Upcomingdata, setUpcomingdata] = useState([]);
  const [Endedata, setEndedata] = useState([]);

  useEffect(async () => {
    let data = await _InfinityFactoryContractGetAllDataByAddress();
    setFactoryContract(data);
    data.map((data, key) => {
      isActive(data);
      isUpcoming(data);
      isEnded(data);
    });
  }, []);

  const isActive = async (fcData) => {
    let raisedAmount = await _IDOSaleTotalCollectedFunds(fcData[2][1]);
    if (
      !(
        parseInt(new Date().getTime() / 1000) >
          fcData[1][4] / Math.pow(10, 18) ||
        fcData[1][2] / Math.pow(10, 18) <= raisedAmount / Math.pow(10, 18)
      )
    ) {
      if (
        (fcData[1][3] / Math.pow(10, 18) <=
          parseInt(new Date().getTime() / 1000) &&
          parseInt(new Date().getTime() / 1000) <
            fcData[1][4] / Math.pow(10, 18)) ||
        raisedAmount / Math.pow(10, 18) > fcData[1][2] / Math.pow(10, 18)
      ) {
        setActivedata((data) => [...data, fcData]);
      }
    }
    return true;
  };

  const isUpcoming = async (fcData) => {
    let raisedAmount = await _IDOSaleTotalCollectedFunds(fcData[2][1]);
    if (
      !(raisedAmount >= fcData[1][2]) &&
      fcData[1][3] / Math.pow(10, 18) >
        parseInt(new Date().getTime() / 1000 || raisedAmount === "")
    ) {
      setUpcomingdata((data) => [...data, fcData]);
    }
    return true;
  };

  const isEnded = async (fcData) => {
    let raisedAmount = await _IDOSaleTotalCollectedFunds(fcData[2][1]);
    if (
      parseInt(new Date().getTime() / 1000) > fcData[1][4] / Math.pow(10, 18) ||
      raisedAmount / Math.pow(10, 18) >= fcData[1][2] / Math.pow(10, 18)
    ) {
      setEndedata((data) => [...data, fcData]);
    }
    return true;
  };

  const handleTimeout = () => {
    // document.getElementById("loading").innerHTML = "Nothing to show yet";
  };

  return (
    <>
      {FactoryContract === null ? (
        <>
          <div style={{ display: "none" }}>
            {setTimeout(handleTimeout, 5000)}
          </div>
          <div
            style={{
              color: "#ff832e",
              textAlign: "center",
              position: "relative",
            }}
          >
            <h3
              id="loading"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Loading />
            </h3>
          </div>
        </>
      ) : (
        <>
          <AllIDOSequence
            Activedata={Activedata}
            Upcomingdata={Upcomingdata}
            Endedata={Endedata}
          />
        </>
      )}
    </>
  );
}

export default AllIDO;
